import { useFlag } from '@calendly/feature-check-react';
import { usePageTitle } from '@calendly/hooks';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { SafeSuspense } from '@calendly/safe-suspense';
import { ArrowExpandIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import { Loader } from '@calendly/ui/components/loader';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetUserProfile } from 'common';
import { TabContainer } from 'features/account_settings/tabs/styles';
import { isFreeOrTrialSelector } from 'features/billing';
import { fetchPhoneNumbers, phoneNumbersLoadingStateSelector } from 'features/phone_numbers';
import { ErrorModalGeneric as ErrorModal } from 'features/workflows';
import { MeetingBriefSettingSection } from './meeting_digest_section';
import { PhoneNumberAdding } from './phone_number_adding';
import { PhoneNumbersList } from './phone_numbers_list';
import { PrimaryPhoneNumber } from './primary_phone_number';
import { SharedEventNotificationSection } from './shared_event_notification_section';
const titleCss = "t5g5q3g";
const Title = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(titleCss, props.className)} />;
});
const LinkWithIcon = ({
  children
}) => <Link href="/app/workflows" target="_blank" rel="opener">
    {children}
    <ArrowExpandIcon inline size="large" />
  </Link>;
const autoSaveTextCss = "a1v0pn5j";
const AutoSaveText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(autoSaveTextCss, props.className)} />;
});
const rowCss = "rmy89k5";
const Row = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rowCss, props.className)} />;
});
const containerCss = "c1jcm1m1";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const Workflows = () => {
  const dispatch = useDispatch();
  const {
    owner_id: ownerId
  } = useGetUserProfile();
  const meetingIntelligenceEnabled = useFlag('meeting_intelligence');
  const meetingPrepEnabled = useFlag('meeting_prep_email');
  const isFreeOrTrialPlan = useSelector(isFreeOrTrialSelector);
  const pageTitle = I18n.t('publisher.account_settings.communication_settings.title');
  usePageTitle(pageTitle);
  useEffect(() => {
    dispatch(fetchPhoneNumbers(ownerId));
  }, [dispatch, ownerId]);
  const phoneNumbersLoadingState = useSelector(phoneNumbersLoadingStateSelector);
  if (phoneNumbersLoadingState === 'loading') {
    return <Loader />;
  }
  if (phoneNumbersLoadingState === 'error') {
    return <ErrorModal />;
  }
  return <SafeSuspense>
      <TabContainer>
        {phoneNumbersLoadingState === 'loaded' && !isFreeOrTrialPlan && <>
              <Row>
                <Title>{I18n.t('publisher.account_settings.phone_numbers.list.title')}</Title>
                <p>
                  {HtmlParser(I18n.t('publisher.account_settings.phone_numbers.list.text'), {
              LinkWithIcon
            })}
                </p>
                <PhoneNumbersList />
                <PhoneNumberAdding />
              </Row>

              <Row>
                <PrimaryPhoneNumber />
              </Row>
            </>}
        <Container>
          <SharedEventNotificationSection />
          {meetingIntelligenceEnabled && meetingPrepEnabled && <MeetingBriefSettingSection />}
        </Container>
        <AutoSaveText>{I18n.t('publisher.account_settings.phone_numbers.auto_save')}</AutoSaveText>
      </TabContainer>
    </SafeSuspense>;
};

require("./component.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./component.js");